import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { SurveyQuestion } from '../models/survey-question.model';
//import { SurveyQuestionVm } from 'src/shared/service-proxies/service-proxies';
//import { StateService } from '../services/state.service';

@Component({
    selector:'ui-text-area',
  styleUrls: ["./ui-styles.css"],
  template: `<mat-form-field
    *ngIf="
      currentQuestion?.dataTypeName == 'textarea'
    "
>
    <textarea matInput 
      [type]="currentQuestion?.dataTypeName"
      [formControl]="textareaInput"
      name="currentQuestion.dataFieldName"
      placeholder="Enter Answer"
      rows="6"
      [(ngModel)]="currentQuestion.answerText"
   >
</textarea>
    <mat-error *ngIf="textareaInput.invalid">
            {{
            getTextInputErrorMessage()
            }}
          </mat-error>
  </mat-form-field>`
})

export class TextAreaComponent implements OnInit {
  textareaInput = new UntypedFormControl("");
  private _currentQuestion: SurveyQuestion;
  @Input() set currentQuestion(value){
   this._currentQuestion = value;
   this.addValidations();
  };
  get currentQuestion(){
   return this._currentQuestion;
  };

  //  constructor(private stateService: StateService) { }

    ngOnInit() { }

    addValidations() {
      let validators = [];
      if (this.currentQuestion.required)
        validators.push(Validators.required);
       if (this.currentQuestion.validations == 'PhoneNumber')
         validators.push(Validators.pattern("^[0-9]{10}$|^[0-9\-]{12}$"));
       if (this.currentQuestion.validations == 'Email')
         validators.push(Validators.pattern("^.+@.+\..+$"));

      if (validators.length > 0) {
        this.textareaInput.setValidators(validators);
      }
      else
        this.textareaInput.setValidators(null);

      this.textareaInput.updateValueAndValidity();
    }

    getTextInputErrorMessage() {
      if (this.currentQuestion) {
      //console.log('invalid ', this.currentQuestion.questionText, this.textInput.invalid)
      if (this.currentQuestion.dataTypeName == 'text' || this.currentQuestion.dataTypeName == 'number')
        return this.textareaInput.hasError("required")
          ? "You must enter a value" : this.textareaInput.hasError("pattern")
             ? this.getFieldSpecificErrorMessage()
             : "";
      }

      return "";
    }

    getFieldSpecificErrorMessage() {
      if (this.currentQuestion.validations == 'PhoneNumber')
       return "Please enter 10 digit phone number"
      if (this.currentQuestion.validations == 'Email')
       return "Please enter a valid email address"
    }
}
